import Tag from '../../../../services/tag'
import Vehicles from '../../../../services/vehicles';
import Sales from '../../../../services/sales';

export default {
  props: ['type', 'vpSelected'],
  data() {
    return {
      loadingModal: undefined,
      requestSuccess: false,
      errorMessage: undefined,
      vehicleFromPlan: undefined,
      vehicleFromList: undefined,
      userPlate: this.vpSelected.plate ? this.vpSelected.plate : this.vpSelected.placaVeiculo,
      userVp: undefined,
      contractVp: undefined,
      serialNumber: undefined,
      linkedTag: false,
      msg: undefined,
    }
  },
  computed: {
    contractCred() {
      const contract =  this.$store.state.contract.contracts.find(contract => contract.plan.planId == 6 || contract.plan.planId == 8);
      return contract.contractId;
    }
  },
  methods: {
    async doRequestDelete() {
      this.errorMessage = undefined;

      if(this.vpSelected.saldoVp > 0) {
        const payload =  [{
          index: 1,
          contractIdDeb :  this.vpSelected.contractIdVp ,//this.rescueData.contractIdVp,
          contractIdCred : this.contractCred,// this.rescueData.contractIdAgr,
          transferValue : this.vpSelected.transferValue,// this.rescueData.transferValue,
          feeValue: this.vpSelected.taxValue,// this.rescueData.taxValue
        }];

        const filter = { transfer: payload };
        
        try {
          await Sales.transferCreditAggregate(filter);
        } catch (e) {
          
          this.errorMessage = e.data.status.message;
        }
      }

      this.loadingModal = Vehicles.deleteAggregateVehicleAndUser({vehicleId: this.vpSelected.vehicleId}).then(res => {
        if (res.status.code == 0) {
          this.requestSuccess = true;
        }
      }).catch(err => {
        this.errorMessage = err.data.status.message;
      });
    },
    doRequestBlock() {
      this.errorMessage = undefined;
      this.loadingModal = this.$validator.validateAll().then((success) => {
        return Tag.blockTagTemp(this.vpSelected.tagSerialNumber, 'Agregado').then(res => {
          if (res.data.status.code == 0) {
            this.requestSuccess = true;
          }
        }).catch(err => {
          this.errorMessage = 'Erro ao bloquear o TAG.';
        });
      })
    },
    doRequestUnblock() {
      this.loadingModal = Tag.unblockTag(this.vpSelected.tagSerialNumber).then((res) => {
        if (res.data.status) {
          this.requestSuccess = true;
        } else {
          this.errorMessage = 'Erro ao desbloquear o TAG.';
        }
      });
    },
    doReplaceTag() {
      let filter = {
        vehicleId: this.vpSelected.vehicleId,
        serialNumber: this.serialNumber,
        moveMaisId: this.vpSelected.moveMaisId,
      };
      this.loadingModal = Tag.replaceTagAggregate(filter).then((res) => {
        if(res.response === 0){
          this.linkedTag = 'success';
          this.msg = 'Tag ativada.';
          this.requestSuccess = true;
        } else {
          this.linkedTag = 'error';
          this.msg = res.status.message;
        }
      }).catch(err => {
        
      });
    },
    closeModal(act) {
      let close = {
        state: act,
        modal: 'block-vehicle'
      };
      this.$emit('close', close);
      // this.userPlate = undefined;
      this.vehicleFromPlan = undefined;
      this.vehicleFromList = undefined;
      this.errorMessage = undefined;
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-block-vehicle.js